import React from 'react';
import { NotificationModeProvider } from '../../../../features/changeMode';
import { OnlyUnreadProvider } from '../../../../features/toggleOnlyUnread';
import { Header } from '../../../../widgets/header';
import { NotificationList } from '../../../../widgets/notificationList';
import { notificationsConfig as config } from '../../../../shared/constants';
import styles from './HasContent.module.scss';

const HasContent = ({ data, onSourceClick }) => {
  const { notifications, modes, unreadCount } = data;

  return (
    <div className={styles.root}>
      <NotificationModeProvider
        initMode={modes.length === 1 ? modes[0] : config.all.name}
      >
        <OnlyUnreadProvider>
          <Header actionsDisabled={!unreadCount} modes={modes} />
          <NotificationList
            notifications={notifications}
            onLinkClick={onSourceClick}
          />
        </OnlyUnreadProvider>
      </NotificationModeProvider>
    </div>
  );
};

export default HasContent;
